import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { Edit as EditIcon, PlayArrow, Assessment as ResultIcon } from '@mui/icons-material';
import TabPanel from '../TabPanel';
import CodeEditor from './CodeEditor';
import EditorToolbar from './EditorToolbar';
import OutputPanel from './OutputPanel';
import TestResultPanel from './TestResultPanel';

/**
 * 代码工作区组件
 * 包含代码编辑器、输出面板和测试结果面板
 */
function CodeWorkspace({
  language = 'python',
  code = '',
  onCodeChange,
  executeResult = null,
  runResult = null,
  onResetCode,
  userRole = 'student',
  question = null
}) {
  const [leftTab, setLeftTab] = useState(0); // 0: Code, 1: Output, 2: Test Result

  // Auto-switch to appropriate tab when results arrive
  React.useEffect(() => {
    if (executeResult) {
      setLeftTab(1); // Switch to Output tab
    }
  }, [executeResult]);

  React.useEffect(() => {
    if (runResult) {
      setLeftTab(2); // Switch to Test Result tab
    }
  }, [runResult]);

  const handleResetCode = () => {
    if (question && window.confirm('确定要重置代码到模板吗？当前代码将会丢失。')) {
      onResetCode(question.templateCode);
    }
  };

  return (
    <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', borderRight: 1, borderColor: 'divider' }}>
      {/* Left Side Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'grey.50', height: 48, display: 'flex', alignItems: 'flex-end' }}>
        <Tabs
          value={leftTab}
          onChange={(e, v) => setLeftTab(v)}
          sx={{ minHeight: 48, height: 48 }}
        >
          <Tab
            label="Code"
            icon={<EditIcon fontSize="small" />}
            iconPosition="start"
            sx={{ minHeight: 48 }}
          />
          <Tab
            label="Output"
            icon={<PlayArrow fontSize="small" />}
            iconPosition="start"
            sx={{ minHeight: 48 }}
          />
          <Tab
            label="Test Result"
            icon={<ResultIcon fontSize="small" />}
            iconPosition="start"
            sx={{ minHeight: 48 }}
          />
        </Tabs>
        {leftTab === 0 && (
          <EditorToolbar
            onResetCode={handleResetCode}
            resetDisabled={!question}
          />
        )}
      </Box>

      {/* Code Tab */}
      <TabPanel value={leftTab} index={0}>
        <CodeEditor
          language={language}
          value={code}
          onChange={onCodeChange}
          readOnly={false}
        />
      </TabPanel>

      {/* Output Tab */}
      <TabPanel value={leftTab} index={1}>
        <OutputPanel executeResult={executeResult} />
      </TabPanel>

      {/* Test Result Tab */}
      <TabPanel value={leftTab} index={2}>
        <TestResultPanel runResult={runResult} userRole={userRole} />
      </TabPanel>
    </Box>
  );
}

export default CodeWorkspace;

